module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#video",
      toString: function () {
        return this.url;
      }
    }